import Hero from "./components/2-hero/Hero";
import Header from "./components/1-header/Header";
import Main from "./components/3-main/Main";
import Contact from "./components/4-contact/Contact";
import Footer from "./components/5-footer/Footer";
import { memo, useEffect, useState } from "react";
import Splash from "./components/6-spalsh/Splash";
import { motion } from "framer-motion";
import Testimonials from "./components/7-experians/Testimonials";

function App() {

  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [shCusrorAnim, setShCusrorAnim] = useState(true)

  useEffect(() => {
    if (shCusrorAnim) {
      const handleCursor = (e) => {
        setX(e.clientX - 20)
        setY(e.clientY - 20)
      }
      window.addEventListener('mousemove', handleCursor)
      return () => window.removeEventListener('mousedown', handleCursor)
    }
  }, [shCusrorAnim])

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setshowScrollBTN(true);
      } else {
        setshowScrollBTN(false);
      }
    });
  }, []);

  const [showScrollBTN, setshowScrollBTN] = useState(false);
  return (
    < div id="up" className="container" >


      {shCusrorAnim && <div className="cursor"
        style={{ transform: `translate(${x}px , ${y}px)` }}
      />}



      <Splash />
      <Header setShCusrorAnim={setShCusrorAnim} shCusrorAnim={shCusrorAnim} />

      <Hero />
      <div className="divider" />
      <Main />
      <div className="divider" />
      <Testimonials />
      <div className="divider" />
      <Contact />
      <div className="divider" />
      <Footer />



      <a style={{ opacity: showScrollBTN ? 1 : 0, transition: "1s" }} href="#up">
        <button className="icon-keyboard_arrow_up scroll2Top"></button>
      </a>
    </div>
  );
}

export default memo(App);
